import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react'
import styled from 'styled-components';
import { maxMobile, maxWidth, primaryColor, primaryFont, primaryHeadingColor, retina, scrollbar, SecondaryColorTwo, secondaryFont, wMBold, wMedium } from '../../../Utils/utilsStyle';
import AlertsSearch from '../../alerts/components/AlertsSearch';
import NewClusterWidget from './NewClusterWidget';
import { actions as companiesAction } from '../../../Slice/CompaniesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectClusterCompanies, selectClusterCompaniesCount, selectClusterCompaniesEnded, selectClusterCompaniesLoading, selectCompanies, selectedSortingType } from '../../../Selector/CompaniesSelector';
import { Company } from '../../../Types/CompaniesTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Checkbox } from 'antd';
import PeopleWidgetWithOutHolo from '../../common/components/PeopleWidgetWithOutHolo';
import { parseColorGradientMixture, valueToObject } from '../../../Utils/UtilityFunctions';
import { ACCOUNT_CLUSTER_LIMIT, CLUSTER_DETAIL_ROUTE } from '../../../Utils/Constants';
import { prefetchClusterDetailRoute } from '../../../Utils/routePrefetch';
import GlobalButton from '../../common/components/GlobalButton';
import DoubleCheckIcon from '../../common/assets/svgIcons/DoubleCheckIcon';
import AffinitySearchResultItemSkeleton from '../../common/skeleton/AffinitySearchResultItemSkeleton';
import SkeletonCustom from '../../common/skeleton/SkeletonCustom';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import { selectAllClusterCompanies, selectClusterDrawerOpen, selectClusterId, selectCreationSuccess, selectDetailsLoading } from '../../../Selector/ClustersSelector';
import { useNavigate } from 'react-router-dom';
import { actions as helperActions } from '../../../Slice/HelperSlice';
import { selectSelectedCompanies } from 'Selector/GlobalSearchResultsSelector';
import { actions as globalSearchActions } from 'Slice/GlobalSearchResultsSlice';
import { SelectedCompany } from 'Types/GlobalSearchResultsTypes';

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 32px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMBold};
  margin-bottom: 0px;
  display: inline-block;
  padding: 0px 33px 16px 33px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 28px;
    line-height: 30px;
  }
  @media all and (max-width: ${maxMobile}){
    padding: 0px 16px;
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 8px;
  }
`;

const ContentWrapper = styled.div`
.drawer-body {
    /* padding: 0px 33px; */
    display: flex;
    flex-direction: column;
    height : calc(100vh - 140px) ;
    .content-box {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 0px 33px;
      .search-div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 16px;
        margin-bottom: 16px;
        flex-shrink: 0;
        .search-box {
          width: 100%;
          .search-wrapper {
            .ant-input-affix-wrapper {
              height: 32px;
              .ant-input {
                max-width: 370px;
                &::placeholder {
                  color: #7E7E7E;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  letter-spacing: -0.4px;
                }
              }
            }
            .cross-icon {
              top: 8px;
              right: 12px;
            }
          }
        }
        .share-btn {
          height: 30px;
          background: ${primaryColor};
          border: 1px solid ${primaryColor};
          border-radius: 22px;
          color: #FFF;
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMBold};
          line-height: 13px;
          letter-spacing: -0.4px;
          padding: 7px 13px;
        }
      }
      .company-count {
        color: ${SecondaryColorTwo};
        font-family: ${primaryFont};
        font-size: 18px;
        font-weight: ${wMedium};
        line-height: 20px;
        letter-spacing: -0.556px;
        margin-bottom: 16px;
      }
      .cluster-company-section {
        min-height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .search-empty-state {
          flex: 1;
          min-height: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 14px 0 0;
        }
        .search-no-results {
          text-align: center;
          .title {
            font-family: ${secondaryFont};
            font-size: 18px;
            font-weight: ${wMBold};
            color: ${primaryHeadingColor};
            margin-bottom: 8px;
          }
          .subtitle {
            font-family: ${secondaryFont};
            font-size: 14px;
            font-weight: ${wMedium};
            color: ${primaryHeadingColor};
            margin-bottom: 0;
          }
        }
        #cluster-company-scrollable-div {
          flex: 1;
          min-height: 0;
          height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          ${scrollbar};
          .infinite-for-company-section {
            .company-list {
              display: flex;
              flex-direction: column;
              row-gap: 10px;
              padding: 2px 14px 0px 0px;
              .company-item {
                padding: 15px 16px;
                border-radius: 10px;
                border: 1px solid #DADADA;
                background: #FFF;
                box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
                cursor: pointer;
                &.selected {
                  border: 2px solid #1EC252;
                }
                .left-section {
                  display: flex;
                  align-items: center;
                  column-gap: 16px;
                  .ant-checkbox-wrapper {
                    width: auto;
                    margin-bottom: 0px;
                  }
                  .person-without-holo {
                    padding: 2px !important;
                  }
                  .company-name {
                    color: #000;
                    font-family: ${secondaryFont};
                    font-size: 20px;
                    font-weight: ${wMedium};
                    line-height: 24px;
                    letter-spacing: -0.417px;
                  }
                }
              }
              .skeleton {
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                .box {
                  display: flex;
                  align-items: center;
                  column-gap: 12px;
                  padding: 14px 16px;
                  border-radius: 10px;
                  border: 1px solid #DADADA;
                  background: #FFF;
                  box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
                }
              }
            }
          }
        }
      }
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      background: #FFF;
      box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.14);
      padding: 0px 24px;
      .selected-count {
        display: flex;
        flex-direction: column;
        .count-section {
          display: flex;
          align-items: center;
          column-gap: 8px;
          .icon {
            width: 22px;
          }
          .text {
            color: ${primaryColor};
            font-family: ${primaryFont};
            font-size: 18px;
            font-weight: ${wMedium};
            line-height: normal;
          }
        }
        .limit-section {
          color: #6A6A6A;
          font-family: Roboto;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin-left: 31px;
          margin-top: -5px;
          max-width: 250px;
        }
        
      }
      .buttons-div {
        display: flex;
        align-items: center;
        column-gap: 8px;
      }
    }
  }
`;
type Props = {
  visible: boolean;
  isAddDrawer?: boolean
  inGlobalSearch?: boolean
}

const defaultProps = {
  visible: false,
  isAddDrawer: false,
  inGlobalSearch: false,
}
const CreateNewClusterSection = function CreateNewClusterSection(props: Props) {
  const { visible, isAddDrawer, inGlobalSearch } = props
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState<number[]>([]);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const initialFetchKeyRef = useRef('');
  const pendingOffsetRef = useRef<number | null>(null);
  const loading = useSelector(selectClusterCompaniesLoading);
  const companiesEnded = useSelector(selectClusterCompaniesEnded);
  const sortingType = useSelector(selectedSortingType);
  const companies: Company[] = useSelector(selectClusterCompanies);
  const companiesCount: number = useSelector(selectClusterCompaniesCount);
  const [clusterName, setClusterName] = useState<string>('');
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);
  const clusterCompanies: Company[] = useSelector(selectAllClusterCompanies);
  const clusterId = useSelector(selectClusterId);
  const clusterCreationSuccess = useSelector(selectCreationSuccess);
  const clusterCreating = useSelector(selectDetailsLoading);

  const existingClusterCompanyIds = useMemo(
    () => new Set(clusterCompanies.map((company) => company.companyId)),
    [clusterCompanies],
  );

  const hasMoreCompanies = !companiesEnded
    && companiesCount > 0
    && companies.length < companiesCount;

  const trimmedSearchTerm = searchTerm.trim();
  const isSearchActive = trimmedSearchTerm.length > 0;
  const showNoSearchResults = isSearchActive && !loading && companies.length === 0;
  const selectedCompaniesInGlobalSearch = useSelector(selectSelectedCompanies) as SelectedCompany[];

  // Companies already picked on the global search screen. They show up pre-selected in this
  // drawer and are counted once — a local re-selection of the same id must not bump the count.
  const globalSelectedCompanyIds = useMemo(
    () => new Set(inGlobalSearch ? selectedCompaniesInGlobalSearch.map((c) => c.companyId) : []),
    [inGlobalSearch, selectedCompaniesInGlobalSearch],
  );

  const allSelectedCompanyIds = useMemo(
    () => [
      ...globalSelectedCompanyIds,
      ...selectedCompanies.filter((id) => !globalSelectedCompanyIds.has(id)),
    ],
    [globalSelectedCompanyIds, selectedCompanies],
  );

  const selectedCountForDisplay = inGlobalSearch
    ? allSelectedCompanyIds.length
    : selectedCompanies.length;

  const remainingClusterSlots = Math.max(0, ACCOUNT_CLUSTER_LIMIT - clusterCompanies.length);
  const isAtSelectionLimit = isAddDrawer
    ? selectedCountForDisplay >= remainingClusterSlots
    : selectedCountForDisplay >= ACCOUNT_CLUSTER_LIMIT;

  const loadMoreAccounts = useCallback(() => {
    if (loading) return;

    const offset = companies.length;
    if (companiesEnded || offset >= companiesCount) return;
    if (pendingOffsetRef.current === offset) return;

    pendingOffsetRef.current = offset;
    dispatch(companiesAction.getCompanies({
      offset,
      sortingType: sortingType || 'dateFollowed:desc',
      ...(trimmedSearchTerm && { searchTerm: trimmedSearchTerm }),
      myAccounts: true,
      mode: 'accountClusters',
      ...(clusterId && { clusterId }),
    }));
  }, [
    companies.length,
    companiesCount,
    companiesEnded,
    dispatch,
    loading,
    sortingType,
    trimmedSearchTerm,
  ]);
  const shouldDisable = selectedCountForDisplay === 0;

  const handleScroll = useCallback(() => {
    const target = scrollContainerRef.current;
    if (!target || loading || !hasMoreCompanies) return;

    const { scrollTop, scrollHeight, clientHeight } = target;
    if (scrollTop + clientHeight >= scrollHeight - 80) {
      loadMoreAccounts();
    }
  }, [hasMoreCompanies, loadMoreAccounts, loading]);

  useEffect(() => {
    if (visible && isAddDrawer) {
      setSelectedCompanies([]);
    }
  }, [visible, isAddDrawer]);

  useEffect(() => {
    if (!visible) {
      initialFetchKeyRef.current = '';
      pendingOffsetRef.current = null;
      return;
    }

    const fetchKey = `${trimmedSearchTerm}|${sortingType || 'dateFollowed:desc'}`;
    if (initialFetchKeyRef.current === fetchKey) {
      return;
    }

    initialFetchKeyRef.current = fetchKey;
    pendingOffsetRef.current = 0;
    dispatch(companiesAction.getCompanies({
      offset: 0,
      sortingType: sortingType || 'dateFollowed:desc',
      ...(trimmedSearchTerm && { searchTerm: trimmedSearchTerm }),
      ...(clusterId && { clusterId }),
      myAccounts: true,
      mode: 'accountClusters',
    }));
  }, [visible, trimmedSearchTerm, sortingType, dispatch]);

  useEffect(() => {
    if (loading) return;
    pendingOffsetRef.current = null;
  }, [loading, companies.length]);

  useEffect(() => {
    const target = scrollContainerRef.current;
    if (!target || !visible) return undefined;

    target.addEventListener('scroll', handleScroll, { passive: true });
    return () => target.removeEventListener('scroll', handleScroll);
  }, [visible, handleScroll]);

  useEffect(() => {
    if (!visible || !isAddDrawer || loading || !hasMoreCompanies) return;
    if (companies.length === 0 || companies.length > 0) return;

    loadMoreAccounts();
  }, [
    visible,
    isAddDrawer,
    loading,
    hasMoreCompanies,
    companies.length,
    companies.length,
    loadMoreAccounts,
  ]);

  useEffect(() => {
    if (clusterCreationSuccess) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('create_Cluster_Clicked', 0, {}),
      ));
      if (clusterId) {
        prefetchClusterDetailRoute(clusterId);
        navigate(`${CLUSTER_DETAIL_ROUTE}${clusterId}`);
      }
      dispatch(clusterActions.setDrawerOpen(false));
      dispatch(clusterActions.resetClusterManageLoading());
    }
  }, [clusterCreationSuccess, clusterId, dispatch, navigate]);

  const onSearching = (value: string) => {
    setSearchTerm(value);
  };

  const handleCompanySelect = (company: Company) => {
    const { companyId } = company;
    if (globalSelectedCompanyIds.has(companyId)) {
      return;
    }
    setSelectedCompanies((prev) => {
      if (prev.includes(companyId)) {
        return prev.filter((id) => id !== companyId);
      }
      const totalSelected = prev.length + globalSelectedCompanyIds.size;
      if (isAddDrawer) {
        if (clusterCompanies.length + totalSelected >= ACCOUNT_CLUSTER_LIMIT) {
          return prev;
        }
        return [...prev, companyId];
      }
      if (totalSelected >= ACCOUNT_CLUSTER_LIMIT) {
        return prev;
      }
      return [...prev, companyId];
    });
  };

  const createHandler = () => {
    // Companies picked from global search that the user does not follow yet have to be
    // followed first, then they go into the cluster along with the rest of the selection.
    const followedCompanyIds: number[] = [];
    if (inGlobalSearch) {
      selectedCompaniesInGlobalSearch.forEach((company) => {
        if (!company.companySubscribed) {
          followedCompanyIds.push(company.companyId);
          dispatch(companiesAction.followCompany({
            companyId: (company.companyId).toString(),
            companyAdded: company.companyName,
          }));
        }
      })
    }
    const companyString = Array.from(
      new Set([...followedCompanyIds, ...allSelectedCompanyIds]),
    ).join(',');
    dispatch(clusterActions.manageAccountCluster({
      type: 'create',
      clusterName: clusterName,
      companyIds: companyString,
    }))
    if (inGlobalSearch) {
      dispatch(globalSearchActions.clearSelectedCompanies())
    }
  }

  const addCompaniesHandler = () => {
    if (selectedCompanies.length === 0) return;
    dispatch(clusterActions.manageAccountCluster({
      type: "edit",
      clusterId: clusterId,
      addedCompanyIds: selectedCompanies.join(','),
      ...(sortingType ? { sortingType } : {}),
    }))
    dispatch(helperActions.callFlurryEvent(
      valueToObject('add_cluster_company', 0),
    ));
    dispatch(helperActions.setNotification({
      message: "Account(s) added to cluster successfully",
      proTip: false,
      rightPlacement: false,
      classnameFlag: true,
      groupId: 0,
    }))
    dispatch(clusterActions.setDrawerOpen(false));
  }

  const cancelHandler = () => {
    setSelectedCompanies([]);
    dispatch(clusterActions.setDrawerOpen(false));
  }

  return (
    <ContentWrapper>
      <div className="drawer-header">
        <Heading>Account Browser</Heading>
      </div>
      <div className="drawer-body">
        <div className='content-box'>
          {
            !isAddDrawer && (
              <NewClusterWidget
                setClusterName={setClusterName}
              />
            )
          }
          <div className="search-div">
            <div className="search-box">
              <AlertsSearch
                placeholderText="Search your Account..."
                query={searchTerm}
                // loading={loading}
                onSearching={onSearching}
                margin="0px"
                height="30px"
              />
            </div>
          </div>
          {!showNoSearchResults && (
            <div className='company-count'>My Accounts {`(${companiesCount})`}</div>
          )}
          <div className='cluster-company-section'>
            {showNoSearchResults ? (
              <div className="search-empty-state">
                <div className="search-no-results">
                  <div className="title">No results found!</div>
                  <div className="subtitle">Try adjusting your search to find.</div>
                </div>
              </div>
            ) : (
              <div
                id="cluster-company-scrollable-div"
                ref={scrollContainerRef}
              >
                <InfiniteScroll
                  key={`cluster-companies-${visible ? 'open' : 'closed'}-${trimmedSearchTerm}-${sortingType || 'dateFollowed:desc'}`}
                  dataLength={companies.length}
                  next={loadMoreAccounts}
                  hasMore={hasMoreCompanies}
                  loader={false}
                  scrollThreshold={0.85}
                  className="o-x-hidden infinite-for-company-section"
                  scrollableTarget="cluster-company-scrollable-div"
                >
                  <div className="company-list">
                    {
                      companies.length > 0 ? (
                        companies.map((company) => {
                          const isSelected = selectedCompanies.includes(company.companyId)
                            || globalSelectedCompanyIds.has(company.companyId);
                          return (
                            <div
                              key={company.companyId}
                              className={`company-item ${isSelected ? 'selected' : ''} ${globalSelectedCompanyIds.has(company.companyId) ? 'disabled' : ''}`}
                              onClick={() => {
                                if (!globalSelectedCompanyIds.has(company.companyId)) {
                                  handleCompanySelect(company);
                                }
                              }}
                              onKeyPress={(event) => {
                                if ((event.key === 'Enter' || event.key === ' ') && !globalSelectedCompanyIds.has(company.companyId)) {
                                  handleCompanySelect(company);
                                }
                              }}
                              role="button"
                              tabIndex={globalSelectedCompanyIds.has(company.companyId) ? -1 : 0}
                              aria-disabled={globalSelectedCompanyIds.has(company.companyId)}
                            >
                              <div className="left-section">
                                <Checkbox
                                  checked={isSelected}
                                  disabled={globalSelectedCompanyIds.has(company.companyId) || (isAtSelectionLimit && !isSelected)}
                                  onClick={(event) => event.stopPropagation()}
                                  onChange={() => {
                                    if (!globalSelectedCompanyIds.has(company.companyId)) {
                                      handleCompanySelect(company);
                                    }
                                  }}
                                />
                                <PeopleWidgetWithOutHolo
                                  key={company?.companyId}
                                  diameter="54px"
                                  diameterSm="54px"
                                  diameterXsm='40px'
                                  marginSm="0px 3px 0px 3px"
                                  margin='0'
                                  wrapperColor={parseColorGradientMixture(company?.companyPersonality)}
                                  logo={company?.companyLogo}
                                  companyId={String(company.companyId) !== '' ? company.companyId : 0}
                                  personForHover
                                  personName={company.companyName}
                                  disableNavigation
                                />
                                <div className='company-name'>{company.companyName}</div>
                              </div>

                            </div>
                          )
                        })) : !loading && companies.length === 0 ? (
                          <div className='no-data'>
                            <div className='text'>No accounts found</div>
                          </div>
                        ) : null
                    }
                    {
                      loading && (
                        <div className="skeleton">
                          {[1, 2, 3, 4, 5, 6].map(() => (
                            <div className='box'>
                              <SkeletonCustom width="40px" height="40px" diameter="50%" margin="0px" />
                              <SkeletonCustom width="240px" height="20px" margin="0px" />
                            </div>
                          ))}
                        </div>
                      )
                    }
                  </div>

                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
        <div className='footer'>
          <div className='selected-count'>
            <div className='count-section'>
              <div className='icon'><DoubleCheckIcon /></div>
              <span className='text'>Account selected {`(${selectedCountForDisplay}/${isAddDrawer ? remainingClusterSlots : ACCOUNT_CLUSTER_LIMIT})`}</span>
            </div>
            {
              isAtSelectionLimit && (
                <div className='limit-section'>
                  Account limit reached.{" "}
                  {
                    isAddDrawer && (
                      <span>Remove an account to add a new one</span>
                    )
                  }
                </div>
              )
            }
          </div>
          <div className='buttons-div'>
            <GlobalButton
              title='Cancel'
              outlineColor={primaryColor}
              textColor={primaryColor}
              innerSpace='9px 21px'
              bgColor='#fff'
              height='36px'
              borderRadius='18px'
              buttonClassName='cancel-btn'
              onButtonClick={cancelHandler}
            />
            {
              isAddDrawer ? (
                <GlobalButton
                  title='Add'
                  outlineColor={primaryColor}
                  textColor='#fff'
                  innerSpace='9px 21px'
                  bgColor={primaryColor}
                  height='36px'
                  borderRadius='18px'
                  buttonClassName='create-btn'
                  disabled={selectedCompanies.length === 0}
                  onButtonClick={addCompaniesHandler}
                />
              ) : (
                <GlobalButton
                  title='Create'
                  outlineColor={primaryColor}
                  textColor='#fff'
                  innerSpace='9px 21px'
                  bgColor={primaryColor}
                  height='36px'
                  borderRadius='18px'
                  buttonClassName='create-btn'
                  disabled={
                    clusterCreating
                    || clusterName.trim().length === 0
                    || shouldDisable
                  }
                  onButtonClick={createHandler}
                />
              )
            }
            {/* <GlobalButton
              title='Create'
              outlineColor={primaryColor}
              textColor='#fff'
              innerSpace='9px 21px'
              bgColor={primaryColor}
              height='36px'
              borderRadius='18px'
              buttonClassName='create-btn'
              disabled={(clusterName.trim().length === 0 || selectedCompanies.length === 0)}
              onButtonClick={createHandler}
            /> */}
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};
CreateNewClusterSection.defaultProps = defaultProps;
export default CreateNewClusterSection;
